import { TextInput } from '../TextInput';
import debounce from 'lodash.debounce';
import { useEffect, useMemo } from 'react';
import { MagnifyingGlassIcon } from '../Icons';
import { Box } from '../Box';
import { jsx as _jsx } from "react/jsx-runtime";
const styledTextInput = {
  width: '50%',
  WebkitFontSmoothing: 'antialiased',
  MozOsxFontSmoothing: 'grayscale'
};

/**
 * The search filter input component
 * @param setFilterData Function used to set the filter data that was selected
 * @param inputValue The current input value
 * @param id The identifier for the instance of the component
 * @constructor
 */
export const FilterInput = _ref => {
  let {
    setFilterData,
    id,
    dataDensity,
    placeholder
  } = _ref;
  const debouncedChangeHandler = useMemo(() => debounce(setFilterData, 250), []);
  // Stop the invocation of the debounced function
  // after unmounting
  useEffect(() => {
    return () => {
      debouncedChangeHandler.cancel();
    };
  }, []);
  return /*#__PURE__*/_jsx(Box, {
    sx: styledTextInput,
    children: /*#__PURE__*/_jsx(TextInput, {
      id: `${id}-TableSearchInput`,
      label: "Search Table",
      placeholder: placeholder || 'Search Table',
      name: "tableSearch",
      onChange: debouncedChangeHandler,
      inputPrefix: /*#__PURE__*/_jsx(MagnifyingGlassIcon, {}),
      size: dataDensity === 'small' ? 'small' : 'large'
    })
  });
};